import { render } from "./handle.vue?vue&type=template&id=7821bd8b&ts=true"
import script from "./handle.vue?vue&type=script&lang=ts"
export * from "./handle.vue?vue&type=script&lang=ts"

import "./handle.vue?vue&type=style&index=0&id=7821bd8b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__